import { DealModel} from './deal.model';

export class DealCustomModel extends DealModel{
    statusDescription: string;
    sellerName: string;
     serviceTypeDesc: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/deal-custom-model.model.ts